import {
  createDocument,
  EnumDocumentUploadStatus,
  updateDocumentStatusById,
} from "@/api/cashier";
import { getSha256Hex, handleUpload } from "@/utils/presigned-upload-handler";
import type { UploadedFile } from "../BankStatementUpload";

const BANK_STATEMENT_FILE_PREFIX = "Bank statement - ";

type PostRequest = {
  uploadedFile: UploadedFile;
  onProgress?: (progress: number) => void;
  onDocumentIdGenerated?: (documentId: string) => void;
};

export const processBankStatementRequest = async ({
  uploadedFile,
  onProgress,
  onDocumentIdGenerated,
}: PostRequest) => {
  if (!uploadedFile.file) {
    return;
  }

  const { data: document } = await createDocument({
    body: {
      name: BANK_STATEMENT_FILE_PREFIX + uploadedFile.file.name,
      checksum: await getSha256Hex(uploadedFile.file),
    },
    throwOnError: true,
  });

  onDocumentIdGenerated?.(document.document_id);

  await handleUpload(
    document.presigned_url,
    uploadedFile.file,
    onProgress,
    document.fields
  );

  await updateDocumentStatusById({
    path: {
      documentID: document.document_id,
    },
    body: {
      status: EnumDocumentUploadStatus.EnumDocumentUploadStatusDone,
    },
    throwOnError: true,
  });
};
